import React from "react";

import { AW23 } from "../../../../js/database/database-aw23-eshop.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const LeatherBraToteBagRed = () => {
  return (
    <ProductsContainer
      pageTitle={AW23.accessories.LeatherBraToteBagRed.itemName}
      name={AW23.accessories.LeatherBraToteBagRed.itemName}
      price={AW23.accessories.LeatherBraToteBagRed.itemPrice}
      fabric={AW23.accessories.LeatherBraToteBagRed.itemFabric}
      src={AW23.accessories.LeatherBraToteBagRed.sizeChart}
      divId={AW23.accessories.LeatherBraToteBagRed.shopifyDivId}
      mainId={AW23.accessories.LeatherBraToteBagRed.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        AW23.accessories.LeatherBraToteBagRed.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={AW23.accessories.LeatherBraToteBagRed.itemName}
              width={AW23.imgWidth}
              height={AW23.imgHeight}
              loading={AW23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default LeatherBraToteBagRed;
